import { defineComponent as _defineComponent } from 'vue'
import { AiChatMessage } from '@/@types/AiChatMessage';
import { AiChatRole } from '@/@types/AiChatRole';
import { sanitizeHtml } from '@/helpers/sanitizeHtml';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchAiChat',
  props: {
    messages: null
  },
  setup(__props: any) {



const getRoleTitle = (role: AiChatRole): string => {
  const roleTitles: Record<AiChatRole, string> = {
    [AiChatRole.USER]: 'You:',
    [AiChatRole.DEVELOPER]: 'Snaplore',
    [AiChatRole.ASSISTANT]: 'Assistant:',
  };
  return roleTitles[role] || 'Unknown';
};

// SNAP-2297: this used to call DOMPurify directly, bypassing the shared helper — so AI chat
// content was rendered without the inline-style allowlist (and without ADD_ATTR: ['target'],
// which silently broke links the model emits with target="_blank").
const sanitizeContent = (content: string) => sanitizeHtml(content);

return { __sfc: true,getRoleTitle, sanitizeContent, AiChatRole }
}

})